import React, { useEffect, useState } from 'react';
import '../RequestLive/RequestLive.scss';
import { Controller, get, useForm } from 'react-hook-form';
import ErrorMessage from '../../../shared/FormComponents/ErrorMessage/ErrorMessage';
import DIContainer from '../../../../config/di.container';
import LocalStorageService from '../../../../services/local.storage.service';
import DITYPES from '../../../../config/di.types';
import Dropdown from "../../../shared/FormComponents/CustomDropdown/CustomDropdown";
import OnBoardingLookupService from '../../../../services/OnboardingService';
import {
    characterRegex, creditCardRegex, cvvRegex, EmailRegex, PhoneRegex,
    userDetailsLocalStorageKey
} from '../../../../common/constant';
import { Months } from '../../../../common/Months';
import '../ActivateAndLaunch/ActivateAndLaunch.scss';
import { CountryModel } from '../../../../common/model/CountryModel';
import UserDetails from '../../../../common/model/UserDetails';
import NotificationService from '../../../../services/NotificationService';
import { EErrorType } from '../../../../common/enum/EErrorType';
import language from "../../../../util/en";
import '../../Onboarding.scss';

export interface IActivateAndLaunchProp {
    handleOnChange: any;
    userDetails: UserDetails;
}

let notificationService: NotificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);
const onboardingLookupService = DIContainer.get<OnBoardingLookupService>(DITYPES.OnboardingLookupService);
const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);
const ActivateAndLaunch: React.FC<IActivateAndLaunchProp> = (props) => {

    const { register, watch, control, handleSubmit, trigger, setValue, formState: { errors } } = useForm();

  
    const localStorageActivateLaunchKey = "ActivateLaunchKey";
    const [showError, setSubmitApiError] = useState(false);   

    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState<boolean>(false);

    useEffect(() => {      
        window.scrollTo(0, 0);
        props.handleOnChange("ActivateAndLaunchForm", 66);
    }, []);     

    const onSubmit = async () => {
        setSubmitButtonDisabled(true);
        setSubmitApiError(false);
        var response = await onboardingLookupService.activateAndLaunchRequest({});

        if (response) {
            notificationService.notifyToster(language.createAccount.ActivateLaunchSuccessMessage, EErrorType.SUCCESS)
            props.handleOnChange("ActivateAndLaunchForm", 100);
            window.location.href = "/home/CompleteSignIn"
        }

        setSubmitButtonDisabled(false);
    };

    const onChangeHandler = (event) => {
        trigger(event.target.name);
    }

    return (
        <div>
            <div className="request-live-container activate-launch-container">
                <span className="ob-heading">Activate & Launch</span>
                <div className="request-live-text">Your Go-Live request is approved. Now you're all set to go live! <br></br>Select Continue to activate and launch.</div>
                <input id="ob-activateLaunch-btn" onClick={(e) => { onSubmit() }} type="submit" value="Continue" className="btn team3-left-button register w-button request-live-continue-button ob-activateLaunch-btn" />
            </div>
        </div>
    );
}
export default ActivateAndLaunch;